<template>
  <div class="visual-element-location">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Titolo mappa"
        :for-id="`visual-element-location-title-${_id}`"
        name="Titolo mappa"
        rules="required"
      >
        <v-input
          :id="`visual-element-location-title-${_id}`"
          type="text"
          name="author"
          v-model="modelDataElement.title"
        />
      </FormRow>
      <FormRow
        label="Descrizione"
        :for-id="`visual-element-location-text-${_id}`"
        name="Descrizione"
        rules="required"
      >
        <v-medium-editor
          :id="`visual-element-location-text-${_id}`"
          name="location"
          v-model="modelDataElement.text"
          row="10"
        />
      </FormRow>

      <FormRow
        label="Cerca il luogo per la mappa"
        legend="non sarà salvata questo valore ma solo la posizione del risultato sulla mappa"
        :for-id="`visual-element-location-where-${_id}`"
        name="Citazione"
      >
        <input
          class="form-input-text mb-4"
          :id="`visual-element-location-where-${_id}`"
          type="text"
          name="whereMap"
          ref="inputBox"
          placeholder="Cerca un posto..."
        />
      </FormRow>
      <p class="form-label">
        Quello che vedi è quello che otterrai, se non ti piace muovi la mappa o
        cambia il livello di zoom.
      </p>
      <div id="map" style="width:100%; height:400px;" ref="map"></div>
    </FormVisualElement>
  </div>
</template>

<script>
/** Components */
import Bugsnag from '@bugsnag/js'
import VisualElementBase from '@/components/VisualElementBase.vue'

const mapsDefault = { lat: 43.15364348098993, lng: 11.858346841738117, zoom: 8 }

export default {
  extends: VisualElementBase,
  mounted() {
    const mapElement = this.$refs.map
    try {
      const vueThis = this

      if (!this.modelDataElement.zoom || this.modelDataElement.zoom === -1) {
        // initilize model with default
        this.modelDataElement.lat = mapsDefault.lat
        this.modelDataElement.lng = mapsDefault.lng
        this.modelDataElement.zoom = mapsDefault.zoom
      }

      const mapMaps = new window.google.maps.Map(mapElement, {
        center: {
          lat: vueThis.modelDataElement.lat,
          lng: vueThis.modelDataElement.lng,
        },
        zoom: vueThis.modelDataElement.zoom,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      })
      mapMaps.addListener('zoom_changed', function() {
        const zoom = mapMaps.getZoom()
        vueThis.modelDataElement.zoom = zoom
      })

      let markers = []

      const updateMarker = () => {
        const center = mapMaps.getCenter()
        if (center) {
          vueThis.modelDataElement.lat = center.lat()
          vueThis.modelDataElement.lng = center.lng()

          markers.forEach(function(marker) {
            marker.setMap(null)
          })
          markers = []

          // Create a marker for each place.
          markers.push(
            new window.google.maps.Marker({
              map: mapMaps,
              position: center,
            }),
          )
        }
      } // updateMarker

      mapMaps.addListener('bounds_changed', updateMarker)

      const inputSearchBox = this.$refs.inputBox
      const searchBox = new window.google.maps.places.SearchBox(inputSearchBox)

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        if (places.length == 0) {
          return
        }

        // For each place, get the icon, name and location.
        var bounds = new window.google.maps.LatLngBounds()
        places.forEach(function(place) {
          if (!place.geometry) {
            // console.log('Returned place contains no geometry')
            return
          }
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport)
          } else {
            bounds.extend(place.geometry.location)
          }
        })
        mapMaps.fitBounds(bounds)
      })
    } catch (err) {
      Bugsnag.notify(err)
    }
  },
  defaultContent: {
    title: '',
    text: '',
    lat: -1,
    lng: -1,
    zoom: -1,
  },
}
</script>
